import { DateService } from '@thewhite/react-global-module/lib/services';
import { DateType } from '@thewhite/react-global-module/lib/types';
import * as t from 'io-ts';
import { BaseEntity, BaseEntityType } from '../../Global/models/baseEntity';

export const MessageType = t.interface({
    id: t.string,
    chatId: t.string,
    author: BaseEntityType,
    text: t.string,
    read: t.boolean,
    createDate: DateType,
    attachments: t.array(BaseEntityType),
});

export interface MessageDto extends t.TypeOf<typeof MessageType> {
}

class Message {
    id: string;
    chatId: string;
    author: BaseEntity;
    text: string;
    read: boolean;
    createDate: Date;
    attachments: BaseEntity[];

    constructor(params: MessageDto) {
        this.id          = params.id;
        this.chatId      = params.chatId;
        this.author      = new BaseEntity(params.author);
        this.text        = params.text;
        this.read        = params.read;
        this.createDate  = DateService.getValidDate(params.createDate) as Date;
        this.attachments = params.attachments.map(attachment => new BaseEntity(attachment));
    }
}

export default Message;
